var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cfdi-related" }, [
    _c("div", { staticClass: "modal-card" }, [
      _vm._m(0),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("AppSelectSearch", {
            attrs: {
              id: "cfdisRelatedType",
              name: "cfdisRelatedType",
              label: "Tipo de relación",
              options: _vm.getRelationTypes(),
              value: _vm.relationTypeSelected
            },
            on: {
              input: function($event) {
                return _vm.onChangeRelationType($event.target.value)
              },
              change: function($event) {
                return _vm.onChangeRelationType($event.target.value)
              }
            }
          }),
          _c("AppPagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "buttons-max": _vm.buttonsMax,
              "pages-total": _vm.totalPages,
              total: _vm.total,
              size: _vm.size
            },
            on: { change: _vm.goToPage }
          }),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(
                "BTable",
                {
                  attrs: {
                    data: _vm.invoices,
                    "checked-rows": _vm.checkedRows,
                    columns: _vm.columns,
                    loading: _vm.loading,
                    "custom-is-checked": function(checkedRows, invoices) {
                      return checkedRows.id === invoices.id
                    },
                    checkable: ""
                  },
                  on: {
                    "update:checkedRows": function($event) {
                      _vm.checkedRows = $event
                    },
                    "update:checked-rows": function($event) {
                      _vm.checkedRows = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c(
                            "BTableColumn",
                            {
                              staticClass: "invoice-column-folio",
                              attrs: {
                                field: "folio",
                                label: "Folio",
                                internal: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.cfdi.voucherSeries) +
                                  " - " +
                                  _vm._s(props.row.cfdi.voucherConsecutive) +
                                  "\n            "
                              )
                            ]
                          ),
                          _c(
                            "BTableColumn",
                            {
                              staticClass: "invoice-column-uuid",
                              attrs: {
                                field: "uuid",
                                label: "UUID",
                                internal: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    props.row.cfdi.complement.digitalTaxStamp
                                      .uuid
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _c(
                            "BTableColumn",
                            {
                              staticClass: "has-text-right",
                              attrs: {
                                field: "total",
                                label: "Monto",
                                internal: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      props.row.cfdi.voucherTotal,
                                      props.row.cfdi.voucherCurrency
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _c(
                            "BTableColumn",
                            {
                              attrs: {
                                field: "moneda",
                                label: "Moneda",
                                internal: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.cfdi.voucherCurrency) +
                                  "\n            "
                              )
                            ]
                          ),
                          _c(
                            "BTableColumn",
                            {
                              staticClass: "invoice-column-receiver",
                              attrs: {
                                field: "receiverName",
                                label: "Receptor",
                                internal: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.cfdi.receiverName) +
                                  "\n            "
                              )
                            ]
                          ),
                          _c(
                            "BTableColumn",
                            {
                              attrs: {
                                field: "fecha",
                                label: "Fecha",
                                internal: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("toHumanDate")(
                                      props.row.cfdi.voucherDate
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass: "content has-text-grey has-text-centered"
                        },
                        [
                          _c(
                            "p",
                            [
                              _c("BIcon", {
                                attrs: {
                                  icon: "emoticon-sad",
                                  size: "is-large"
                                }
                              })
                            ],
                            1
                          ),
                          _c("p", [
                            _vm._v("No se encontraron facturas de este cliente")
                          ])
                        ]
                      )
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "button",
          {
            staticClass: "button",
            attrs: { type: "button" },
            on: { click: _vm.closeModal }
          },
          [_vm._v("\n        Cerrar\n      ")]
        ),
        _c(
          "button",
          {
            staticClass: "button is-secondary",
            attrs: { disabled: !_vm.checkedRows.length, type: "button" },
            on: { click: _vm.addInvoices }
          },
          [_vm._v("\n        Agregar facturas\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v("\n        CFDI Relacionados\n      ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }